module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_09.26e9d84b.jpg";